import styled from "@emotion/styled"
import colors from "theme/colors"
import { LineVector, NewText } from "ui"

const StyledBox = styled.button`
  min-height: 76px;
  width: 160px;
  padding: 12px 16px;
  box-shadow: 0px 0px 12px 0px rgba(21, 62, 105, 0.16);
  // padding: 12px 16px;
  border-radius: 10px;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  background-color: ${colors.white};
  /* gap: 10px; */
  cursor: pointer;
  border: none;
  font-family: inherit;
  ${(props) => props.theme.breakpoints.between("md", "lg")} {
    padding: 8px 10px;
    width: 104px;
    min-height: 53px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 12px 16px;
    min-height: 76px;
    width: 156px;
  }
`

type Props = {
  data: {
    url: string
    id: number
    name: string
    title: string
    numberOfJobs: number
  }
  index: number
  onCardClick: (id: number) => void
  color: any
}

function CategoryCard({ data, onCardClick, color }: Props) {
  const usedColor = color.color
  const onClick = () => {
    if (data.numberOfJobs === 0) {
      return
    }
    onCardClick(data.id)
  }
  return (
    <StyledBox
      aria-label={`${data.title} - ${data.numberOfJobs} משרות פתוחות`}
      onClick={onClick}
    >
      <LineVector width={25} color={`#${usedColor}`} height={2} />
      <NewText
        component={"h3"}
        desktopFontSize={12}
        desktopLineHeight={"18px"}
        largeDesktopFontSize={16}
        largeDesktopLineHeight="24px"
        desktopFontWeight={600}
        mobileLineHeight={"24px"}
        mobileFontSize={16}
        mobileFontWeight={500}
      >
        {data.title ?? data.name}
      </NewText>
      <NewText
        component={"p"}
        desktopFontSize={12}
        desktopLineHeight={"16px"}
        largeDesktopLineHeight="20px"
        largeDesktopFontSize={14}
        color={"#5C6474"}
        mobileLineHeight={"20px"}
        mobileFontSize={14}
        mobileFontWeight={400}
      >
        {data.numberOfJobs + " "}
        משרות
      </NewText>
    </StyledBox>
  )
}

export default CategoryCard
